<template>
	<div id="" class="dis-flex">
		<div class="d-box d-box1">
			<div class="title">所有订单合成的上画单</div>
			<el-date-picker
			  v-model="value1"
			  type="date"
			  style="width: 100%;"
			  value-format="yyyy-MM-dd"
			  placeholder="选择日期">
			</el-date-picker>
			<br>
			<el-button
			  @click="onDownload1"
			  class="row-btn btn"
			  type="primary"
			  >下载</el-button
			>
		</div>
		<div class="d-box ">
			<div class="title">固定日期切换点位所有订单合成的上画单</div>
			<el-date-picker
			  v-model="value2"
			  type="date"
			  style="width: 100%;"
			  value-format="yyyy-MM-dd"
			  placeholder="选择日期">
			</el-date-picker>
			<br>
			<el-button
			  @click="onDownload2"
			  class="row-btn btn"
			  type="primary"
			  >下载</el-button
			>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				value1:'',
				value2:''
			}
		},methods:{
			onDownload1(){
				if(!this.value1) return this.$message.error('请选择日期')
				let sesion = this.getCookie('PHPSESSID') 
				let apiUrl = this.$baseUrl + `/admin/order/downloadAllPainted?date=${this.value1}&PHPSESSID=${sesion}`
				window.open(apiUrl)
				// console.log(this.value1);
			},
			onDownload2(){
				if(!this.value2) return this.$message.error('请选择日期')
				let sesion = this.getCookie('PHPSESSID')
				let apiUrl = this.$baseUrl + `/admin/order/downloadSwitchALlPainted?date=${this.value2}&PHPSESSID=${sesion}`
				window.open(apiUrl)
				// console.log(this.value1);
			},
			// 获取cookie
			getCookie(name) {
			 var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			 if (arr = document.cookie.match(reg))
			  return (arr[2]);
			 else
			  return null;
			},
		}
	}
</script>

<style lang="scss" scoped>
	.d-box{
		width: 25%;
		border: 1px solid #DCDFE6;
		background-color: white;
		padding: 30px;
		border-radius: 10px;
		.title{
			margin-bottom: 10px;
		}
		.btn{
			width: 100%;
			margin-top: 10px;
		  background-color: #004F9D;
		  padding: 12px;
		}
	}
	.d-box1{
		margin-right: 50px;
	}
</style>
